import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

export class RemoveConstantUnitAttribute extends CommandBase {
    uid: string;

    constructor(uid: string) {
        super();
        this.uid = uid;
    }

    execute(state: RemoteConstantsModel): boolean {
        if (state.unitAttributes === undefined) {
            return false;
        }

        const index = state.unitAttributes.findIndex(a => a.uid === this.uid);
        if (index < 0) {
            return false;
        }

        state.unitAttributes.splice(index, 1);
        return true;
    }
}